import Icon from '../../components/Icon.vue'

Icon.register({"regular/bell":{"width":448,"height":512,"paths":[{"d":"M425.4 330.9C408.4 314.2 390.9 296.8 390.9 214.9 390.9 131.8 329.9 62.8 250.4 50.1A31.8-31.8 0 0 1 256 32C256 14.3 241.7 0 224 0S192 14.3 192 32A31.8-31.8 0 0 1 197.6 50.1C118.1 62.8 57.1 131.8 57.1 214.9 57.1 296.8 39.6 314.1 22.6 330.9-25.5 378.4 9.7 448 66.9 448H160C160 483.3 188.7 512 224 512 259.3 512 288 483.3 288 448H381.1C438.3 448 473.5 378.4 425.4 330.9zM224 472C210.8 472 200 461.2 200 448H248C248 461.2 237.2 472 224 472zM381.1 400H66.9C50.1 400 41.8 379.6 53.6 367.8 82.2 339.2 105.1 312.1 105.1 214.9 105.1 149.3 158.5 96 224 96S342.9 149.3 342.9 214.9C342.9 312.5 366.1 339.4 394.4 367.8 406.3 379.7 397.8 400 381.1 400z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/bell.js
// module id = null
// module chunks = 